import { createAddCartTracker } from '@/utils/addCart/createAddCartTracker';
import { createShoplazzaAdapter } from '@/utils/addCart/adapters/shoplazza';

const shoplazzaAddCart = (load) => {
  createAddCartTracker({
    adapter: createShoplazzaAdapter(),
    load,
    initialStoreDelayMs: 2000,
    // master 触发路径检测到变化时立即写 _cartsee_items（shopline 才是延迟 2000ms）
    triggerStoreDelayMs: 0,
  }).start();
};

export { shoplazzaAddCart };
